/**
 * ContractDrawerExtractionBody public entry point.
 *
 * Re-exports the Container, which wraps the pure View with a sibling
 * `useContractExtraction(playerId, "TRANSFER_AGREEMENT")` fetch so
 * the drawer body can surface the Transfer Agreement tab without
 * routing a second query through the already-busy top-level drawer
 * container (SE-4347 AC-7).
 * @module features/contracts/components/ContractDrawerExtractionBody
 */
export { default } from "./ContractDrawerExtractionBodyContainer";
